import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("order-detail", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("order-detail")
      ) {
        return {
          type: "order-detail",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        classes: ["order-detail", "flex-1"],
        components: /*html*/ `
          <section class="bg-[#F5F5F5] py-20 my-10">
            <!-- {% order_detail as order_dict %} -->

            <div class="container mx-auto">
              <div
                class="flex flex-col justify-center items-center gap-y-6 mx-3 md:mx-0"
              >
                <div class="text-center font-semibold">
                  <p class="text-[var(--primary)] font-montserrat text-4xl font-bold">
                    Thank You
                  </p>
                  <p>
                    We’ve received your order and sent an email to
                    <!-- {% comment %} -->
                    abc@gmail.com
                    <!-- {% endcomment %} -->
                    <!-- {{ order_dict.order.shipping_info.email }} -->
                  </p>
                  <p>
                    Click Our
                    <a href="/sale" class="text-[var(--primary)]">New Sale</a> for more
                    products
                  </p>
                </div>
                <div class="grid grid-cols-2 md:gap-x-10 md:w-[70%] md:gap-y-6">
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300 "
                    >
                      Order Number
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      SSN896589
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.tracking_number }} -->
                    </p>
                  </div>
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300"
                    >
                      Order Date
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      12-12-1012
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.created }} -->
                    </p>
                  </div>
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300"
                    >
                      Payment Method
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      Cash On Delivery
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.payment_method.name }} -->
                    </p>
                  </div>
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300"
                    >
                      Contact Number
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      +9779847612345
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.shipping_info.phone }} -->
                    </p>
                  </div>
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300"
                    >
                      Email
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      abc@gmail.com
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.shipping_info.email }} -->
                    </p>
                  </div>
                  <div class="flex flex-col gap-y-2">
                    <p
                      class="text-sm text-gray-500  w-full border-b border-gray-300"
                    >
                      Shipping address
                    </p>
                    <p class="font-semibold ">
                      <!-- {% comment %} -->
                      Baneshowr, KTM
                      <!-- {% endcomment %} -->
                      <!-- {{ order_dict.order.get_shipping_address }} -->
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        `,
      },
    },
  });
};
